// 公用js，建议使用IIFE（立即执行函数）
(function () {
  if ($('.last-page').length > 0) {
    var lastHref = $('.last-page').attr('href');
    var tempHref1 = lastHref.split('-')[0];
    var tempHref2 = lastHref.split('-')[1];
    var lastPageNum = parseInt(tempHref2.split('.')[0]);
    $('.yn-pagination .last-page').after(
      '<span class="page-num total-page-num" >共' +
        lastPageNum +
        '页</span><span class="page-num go-page"  style="cursor: pointer;">转到</span><span class="page-num" style="padding-left:5px;padding-right:5px;"><input name="pageinput" type="text" class="page-input" style="border:none; width:50px;  outline: none; text-align:center;"></span>'
    );
    $('.yn-pagination .go-page').on('click', function () {
      var pageNum = parseInt($('.page-input').val());

      if (pageNum === '') {
        alert('请输入页码！');
        return false;
      }
      if (isNaN(pageNum) || pageNum <= 0 || pageNum > lastPageNum) {
        alert('请输入正确页码！');
        return false;
      }
      toHref = tempHref1 + '-' + pageNum + '.html';
      window.location.href = toHref;
    });
  }

  $('a[target$="_blank"]').attr('rel','noopener noreferrer');

    var url = window.location.pathname,
    reg = new RegExp('/(news|image|download)-([0-9]+).html');
  if ((reg = url.match(reg))) {
    var model = reg[1],
      id = reg[2];
    $.ajax({
      type: 'get',
      url: '/home/info/view',
      data: { model: model, id: id },
      success: function (res) {
        var view = res.result.data.view || 0;
        $('.J_views').text(view);
      }
    });
  }
})();

//# sourceMappingURL=module.js.map
